// Current-room message search. The server scans the complete canonical JSONL;
// the browser never treats its recent rendered message window as the corpus.
interface ChatSearchResult { seq: number; role: string; senderName: string | null; content: string; timestamp: string }

document.addEventListener("DOMContentLoaded", () => {
  const button = document.getElementById("chatSearchBtn");
  const panel = document.getElementById("chatSearchPanel");
  const form = document.getElementById("chatSearchForm");
  const input = document.getElementById("chatSearchInput");
  const closeButton = document.getElementById("chatSearchClose");
  const statusEl = document.getElementById("chatSearchStatus");
  const resultsEl = document.getElementById("chatSearchResults");
  if (!(button instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)
    || !(form instanceof HTMLFormElement) || !(input instanceof HTMLInputElement)
    || !(closeButton instanceof HTMLButtonElement) || !(statusEl instanceof HTMLElement)
    || !(resultsEl instanceof HTMLElement)) return;

  const searchButton = button;
  const searchPanel = panel;
  const searchInput = input;
  const searchStatus = statusEl;
  const searchResults = resultsEl;

  function setOpen(open: boolean) {
    searchPanel.hidden = !open;
    searchButton.setAttribute("aria-expanded", String(open));
    if (open) searchInput.focus();
  }
  function senderLabel(result: ChatSearchResult): string {
    if (result.senderName) return result.senderName;
    if (result.role === "artifact") return "🗂️ 아티팩트";
    return result.role === "user" ? "사용자" : "에이전트";
  }
  function searchTimestampLabel(value: string): string {
    return typeof formatChatTimestamp === "function" ? formatChatTimestamp(value) : "";
  }
  function renderResults(items: ChatSearchResult[]) {
    searchResults.textContent = "";
    for (const item of items) {
      const row = document.createElement("button");
      row.type = "button";
      row.className = "chat-search-result";
      row.dataset.seq = String(item.seq);
      const meta = document.createElement("span");
      meta.className = "chat-search-result-meta";
      meta.textContent = `${senderLabel(item)} · ${searchTimestampLabel(item.timestamp)}`;
      const excerpt = document.createElement("span");
      excerpt.className = "chat-search-result-text";
      excerpt.textContent = item.content.length > 180 ? `${item.content.slice(0, 180)}…` : item.content;
      row.append(meta, excerpt);
      searchResults.appendChild(row);
    }
  }

  button.addEventListener("click", () => setOpen(panel.hidden));
  closeButton.addEventListener("click", () => setOpen(false));
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const query = input.value.trim();
    if (!query) return;
    if (!window.currentSessionId) {
      searchStatus.textContent = "먼저 검색할 대화방을 열어 주세요.";
      return;
    }
    const requestedSessionId = window.currentSessionId;
    searchStatus.textContent = "검색 중…";
    searchResults.textContent = "";
    try {
      const response = await fetch(`/api/sessions/${encodeURIComponent(requestedSessionId)}/messages/search?q=${encodeURIComponent(query)}&limit=50`);
      const payload = await response.json();
      if (!response.ok || !payload.ok) throw new Error(payload.error || "검색하지 못했어요.");
      if (window.currentSessionId !== requestedSessionId) return;
      const items = Array.isArray(payload.results) ? payload.results as ChatSearchResult[] : [];
      searchStatus.textContent = items.length ? `${items.length}건 찾았어요.` : "일치하는 대화가 없어요.";
      renderResults(items);
    } catch (error) {
      searchStatus.textContent = error instanceof Error ? error.message : "검색하지 못했어요.";
    }
  });
  searchResults.addEventListener("click", async (event) => {
    const target = event.target instanceof Element ? event.target.closest<HTMLElement>(".chat-search-result") : null;
    const seq = target?.dataset.seq;
    if (!seq) return;
    const numericSeq = Number(seq);
    if (!Number.isInteger(numericSeq) || numericSeq < 0) return;
    if (window.currentSessionId && window.ChatTimelineSurfaces?.jumpToSeq) {
      searchStatus.textContent = "원문으로 이동 중…";
      const found = await window.ChatTimelineSurfaces.jumpToSeq(window.currentSessionId, numericSeq);
      searchStatus.textContent = found ? "" : "원문을 찾지 못했어요.";
      return;
    }
    const chatContainer = document.getElementById("chatMessages");
    const escapedSeq = typeof CSS !== "undefined" && typeof CSS.escape === "function"
      ? CSS.escape(seq)
      : seq.replace(/["\\]/g, "\\$&");
    const message = chatContainer instanceof HTMLElement
      ? chatContainer.querySelector<HTMLElement>(`.message[data-msg-seq="${escapedSeq}"]`)
      : null;
    if (!message) {
      searchStatus.textContent = "검색 결과는 이전 대화에 있어요. 위로 스크롤하면 원문 위치를 볼 수 있어요.";
      return;
    }
    jumpToAnchoredMessage(numericSeq);
  });
});
